import LocationSettingsRoute from 'garaje/pods/location-settings/route';

class ManageLocationSettingsRoute extends LocationSettingsRoute {}

export default ManageLocationSettingsRoute;
